import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { Project } from '@/types/crm';

export function useInspectorProjects(inspectorId?: string) {
  return useQuery({
    queryKey: ['inspector-projects', inspectorId],
    queryFn: async () => {
      if (!inspectorId) return [];

      // First, get all project assignments for this inspector
      const { data: assignments, error: assignmentsError } = await supabase
        .from('project_assignments')
        .select('project_id, assigned_at')
        .eq('portal_user_id', inspectorId)
        .order('assigned_at', { ascending: false });

      if (assignmentsError) throw assignmentsError;
      if (!assignments?.length) return [];

      // Then fetch the actual projects
      const projectIds = assignments.map(a => a.project_id);
      const { data: projects, error: projectsError } = await supabase
        .from('projects')
        .select('*')
        .in('id', projectIds)
        .is('deleted_at', null);

      if (projectsError) throw projectsError;

      // Sort projects according to assignment order
      const orderMap = new Map(assignments.map((a, i) => [a.project_id, i]));
      return ((projects || []) as unknown as Project[]).sort(
        (a, b) => (orderMap.get(a.id) ?? 0) - (orderMap.get(b.id) ?? 0)
      );
    },
    enabled: !!inspectorId,
  });
}
